import axios, { AxiosPromise } from 'axios';
import config from '@/config';
import { urlParamBuilder } from '@/helpers/urlParamBuilder';
import { Project } from '@/modules/nomenclature/models/project';
import { BudgetLine } from '@/modules/nomenclature/models/budgetLine';

const resourceEndpoint = `${config.api.url}${config.api.privateEndpointsPrefix}${config.api.endpoints.nomenclature}/projects`;

export function fetchAll(): AxiosPromise<Project[]> {
  return axios.get(`${resourceEndpoint}/all`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function fetchChildren(project: Project): AxiosPromise<Project[]> {
  return axios.get(`${resourceEndpoint}/${project.id}/children`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function fetchById(projectId: string): AxiosPromise<Project> {
  return axios.get(`${resourceEndpoint}/${projectId}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function create(project: Project): AxiosPromise<Project> {
  return axios.post(
    `${resourceEndpoint}`,
    { project },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function update(project: Project): AxiosPromise<Project> {
  return axios.put(
    `${resourceEndpoint}/${project.id}`,
    { project },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function destroy(projectId: string, param?: { onDeleteCascade?: boolean }): AxiosPromise<void> {
  const urlParam = urlParamBuilder(param);

  return axios.delete(`${resourceEndpoint}/${projectId}?${urlParam}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function createBudgetLine(projectId: string, budgetLine: BudgetLine): AxiosPromise<BudgetLine> {
  return axios.post(
    `${resourceEndpoint}/${projectId}/budget-lines`,
    { budgetLine },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function fetchBudgetLineById(budgetLineId: string): AxiosPromise<BudgetLine> {
  return axios.get(`${resourceEndpoint}/budget-lines/${budgetLineId}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function updateBudgetLine(budgetLine: BudgetLine): AxiosPromise<BudgetLine> {
  return axios.put(
    `${resourceEndpoint}/budget-lines/${budgetLine.id}`,
    { budgetLine },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function destroyBudgetLine(budgetLineId: string, param?: { onDeleteCascade?: boolean }): AxiosPromise<void> {
  const urlParam = urlParamBuilder(param);

  return axios.delete(`${resourceEndpoint}/budget-lines/${budgetLineId}?${urlParam}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}
